import React from 'react';
import PropTypes from 'prop-types';
import PopularFAQsStyles from './PopularFAQs.styled';
import ButtonLink from '../Shared/ButtonLink';
import Link from '../Shared/Link';
import { useInView } from 'react-intersection-observer';

const defaultLink = {
  to: '/resources/faqs/',
  title: 'View all',
};

const PopularFAQs = ({
  title = 'Popular FAQs',
  children,
  link = defaultLink,
  faqs = [],
  isAnimated = true,
  borders = false,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });

  return (
    <PopularFAQsStyles
      ref={ref}
      borders={borders}
      className={`block-popular_faqs ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        <div className='cta'>
          {title && <h2>{title}</h2>}
          <div className='content'>{children}</div>
          {link && link.to && link.title && (
            <ButtonLink appearance='light' outline {...link}>
              {link.title}
            </ButtonLink>
          )}
        </div>
        <div className='faqs'>
          {faqs.length !== 0 && (
            <ul>
              {faqs.map(({ title: linkTitle, url, ...props }, i) => (
                <li key={i}>
                  <Link to={url} {...props}>
                    {linkTitle}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </PopularFAQsStyles>
  );
};

PopularFAQs.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  link: PropTypes.shape({
    title: PropTypes.string,
    to: PropTypes.string,
  }),
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
  isAnimated: PropTypes.bool,
};

export default PopularFAQs;
